import logo from "../../assets/Logo/logo.png";
import { Link } from "react-router-dom";
import { ROUTES } from "../../constants/routes";
import { useT } from "../../hooks/useT";

export default function MobileGate() {
  const { t } = useT();
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-indigo-50 flex flex-col items-center justify-center px-6 py-12">
      <div className="max-w-sm w-full text-center">
        <img
          src={logo}
          alt="DysTest"
          className="h-12 mx-auto mb-8"
        />

        {/* Laptop illustration */}
        <div className="mb-6 flex justify-center">
          <svg
            viewBox="0 0 96 72"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="w-32 h-auto"
            aria-hidden="true"
          >
            {/* Screen */}
            <rect x="12" y="4" width="72" height="46" rx="4" fill="#1a3a8a" />
            <rect x="16" y="8" width="64" height="38" rx="2" fill="#e8edf8" />
            {/* Hinge */}
            <rect x="8" y="50" width="80" height="5" rx="2" fill="#1a3a8a" />
            {/* Base */}
            <path d="M4 55 Q4 62 12 62 L84 62 Q92 62 92 55 Z" fill="#2952b3" />
            {/* Gaze-dot illustration on screen */}
            <circle cx="48" cy="27" r="5" fill="#6366f1" opacity="0.7" />
            <circle cx="32" cy="20" r="2.5" fill="#1a3a8a" opacity="0.4" />
            <circle cx="64" cy="20" r="2.5" fill="#1a3a8a" opacity="0.4" />
            <circle cx="36" cy="34" r="2.5" fill="#1a3a8a" opacity="0.4" />
            <circle cx="60" cy="34" r="2.5" fill="#1a3a8a" opacity="0.4" />
          </svg>
        </div>

        <h1 className="text-2xl font-bold text-slate-800 mb-3 leading-snug">
          {t('mg_title')}
        </h1>

        <p className="text-slate-600 text-base leading-relaxed mb-6 whitespace-pre-line">
          {t('mg_body')}
        </p>

        <div className="bg-indigo-50 border border-indigo-100 rounded-xl p-4 text-left">
          <p className="text-sm font-semibold text-indigo-900 mb-2">{t('mg_howTo')}</p>
          <ol className="text-sm text-indigo-800 space-y-1 list-decimal list-inside">
            <li>{t('mg_step1')}</li>
            <li>{t('mg_step2')}</li>
            <li>{t('mg_step3')}</li>
          </ol>
        </div>

        <div className="mt-6 flex flex-col gap-3">
          <Link
            to={ROUTES.HOME}
            className="inline-flex min-h-11 items-center justify-center rounded-md bg-indigo-700 px-4 py-3 text-sm font-semibold text-white hover:bg-indigo-800 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-700"
          >
            {t('mg_returnHome')}
          </Link>
        </div>
      </div>
    </div>
  );
}
